import PropTypes from 'prop-types';

export function AssetPlaceholder(props) {
  const { icon, text = 'File type not supported' } = props;

  const failedStyle = () => (text.includes('failed') ? 'failed' : '');

  return (
    <div className="asset-placeholder">
      {icon}
      <div className={`asset-placeholder-text ${failedStyle()}`}>{text}</div>
    </div>
  );
}

AssetPlaceholder.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string,
};

export default AssetPlaceholder;
